import React from 'react';

import Placeholder from 'components/consumer/Placeholder';

const PDPPriceAndFinancePlaceholder = () => (
  <Placeholder
    type="rect"
    loading
    className="!w-full lg:!w-[310px]"
    style={{ height: '23px' }}
  />
);

export default PDPPriceAndFinancePlaceholder;
